//@flow
//Action Type Registered
export const LETO_INV_SUBMIT_SUCCESS='LETO_INV_SUBMIT_SUCCESS';
export const LETO_INV_SUBMIT_ERROR='LETO_INV_SUBMIT_ERROR';
export const LETO_INV_SUBMITTED_COMPLETED='LETO_INV_SUBMITTED_COMPLETED';
export const LETO_EDIT_VERIFY_FORM_DATA_SUCCESS='LETO_EDIT_VERIFY_FORM_DATA_SUCCESS'
export const LETO_EDIT_VERIFY_FORM_DATA_ERROR='LETO_EDIT_VERIFY_FORM_DATA_ERROR'
export const LETO_UPDATE_FORM_ERROR='LETO_UPDATE_FORM_ERROR'
export const REFRESH_LETO_VENDORS_SUCCESS='REFRESH_LETO_VENDORS_SUCCESS';
export const REFRESH_LETO_VENDORS_ERROR='REFRESH_LETO_VENDORS_ERROR';


// WEBPACK FOOTER //
// ./src/redux/leto/actionTypes.js